import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Subscription } from 'rxjs';

import { UploadResponse, SchemaValidationMessage } from '../../../../models/project-upload.model';
import { ProjectUploadService } from '../../../../services/project-upload.service';
import { ToastNotificationService } from '../../../../services/toast-notification.service';
import { findFirstNonEmptyString } from '../../../../utils';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'frmg-mismatch-in-files-dialog',
  templateUrl: './mismatch-in-files-dialog.component.html',
  styleUrls: ['./mismatch-in-files-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, MatButton]
})
export class MismatchInFilesDialogComponent implements OnInit, OnDestroy {
  @ViewChild(CdkVirtualScrollViewport) viewport!: CdkVirtualScrollViewport;

  log: SchemaValidationMessage;
  loading = false;
  missingColumnsList: string[] = [];
  extraColumnsList: string[] = [];

  private readonly sub = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { projectId: string; file: UploadResponse },
    private dialogRef: MatDialogRef<MismatchInFilesDialogComponent>,
    private uploadService: ProjectUploadService,
    private cdr: ChangeDetectorRef,
    private notificationService: ToastNotificationService
  ) {}

  ngOnInit(): void {
    this.loadSchemaValidation();
  }

  private loadSchemaValidation(): void {
    this.loading = true;
    this.cdr.markForCheck();

    this.uploadService.getSchemaValidationMessage(this.data.projectId, this.data.file.upload_id).subscribe({
      next: (res) => {
        this.log = res;
        this.missingColumnsList = res.validation_data?.missing_fields || [];
        this.extraColumnsList = res.validation_data?.extra_fields || [];
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  confirmUpload(): void {
    this.uploadService.confirmUploadSchema(this.data.projectId, this.data.file.upload_id, {}).subscribe({
      next: () => {
        this.notificationService.showNotification({ type: 'success', message: 'File upload confirmed!', verticalPosition: 'bottom' });
        this.close();
      },
      error: (err) => {
        this.notificationService.showNotification({ type: 'error', message: findFirstNonEmptyString(err.error) || 'File upload failed', verticalPosition: 'bottom' });
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get file(): UploadResponse {
    return this.data.file;
  }
}
